import { AxiosResponse } from 'axios';

export class BaseService {
    constructor(private module: string, private isIdentity = false) {}

    protected getUrl(suffix: string, params?: Record<string, string | string[]>) {
        const baseUrl = this.isIdentity
            ? process.env.VUE_APP_IDENTITY_SERVER_URL + 'api/'
            : process.env.VUE_APP_API_URL;
        let url = `${baseUrl}v1/${!!this.module ? this.module + '/' : ''}${suffix}`;

        if (!!params && !!Object.keys(params).length) {
            const urlParams = new URLSearchParams();
            for (const [key, value] of Object.entries(params))
                if (typeof value === 'string') urlParams.append(key, value);
                else for (const v of value) urlParams.append(key, v);

            url = `${url}?${urlParams.toString()}`;
        }

        return url;
    }

    protected isOK(res: AxiosResponse | number) {
        const status = typeof res === 'number' ? res : res.status;
        return status >= 200 && status <= 299;
    }
}
